import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularErrorCircle: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_error-circle"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="error-circle icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M21.9998 3.66602C32.1253 3.66602 40.3332 11.8757 40.3332 21.9993C40.3332 32.123 32.1253 40.3327 21.9998 40.3327C11.8743 40.3327 3.6665 32.123 3.6665 21.9993C3.6665 11.8757 11.8743 3.66602 21.9998 3.66602ZM21.9998 6.72218C13.5757 6.72218 6.72267 13.5752 6.72267 21.9993C6.72267 30.4235 13.5757 37.2765 21.9998 37.2765C30.424 37.2765 37.277 30.4235 37.277 21.9993C37.277 13.5752 30.424 6.72218 21.9998 6.72218ZM21.9974 26.5868C23.0086 26.5868 23.8283 27.4065 23.8283 28.4177C23.8283 29.4288 23.0086 30.2485 21.9974 30.2485C20.9862 30.2485 20.1665 29.4288 20.1665 28.4177C20.1665 27.4065 20.9862 26.5868 21.9974 26.5868ZM21.9897 12.8327C22.6858 12.8321 23.2615 13.3489 23.3531 14.02L23.3658 14.2066L23.3724 22.4595C23.373 23.2189 22.7579 23.835 21.9985 23.8356C21.3024 23.8362 20.7267 23.3193 20.6351 22.6483L20.6224 22.4617L20.6158 14.2088C20.6152 13.4494 21.2303 12.8333 21.9897 12.8327Z" />
      </svg>
    </span>
  );
};

export { RegularErrorCircle };
